
import { Component, ElementRef } from '@angular/core';
import { PageBase } from 't4core';
@Component({
  selector: 'EarningsPerRentalObject',
  templateUrl: './EarningsPerRentalObject.html',
}) 
export class EarningsPerRentalObjectComponent extends PageBase {
    constructor(el: ElementRef) {
      super(el, "EarningsPerRentalObject");
    }
}
